module.exports = __webpack_public_path__ + "img/acta-nacim.813fb520.png";